import { Box } from "@chakra-ui/react";
import Container from '@/components/partials/Container';
import Live from "./header/Live"
import BaseMenu from "./header/BaseMenu"
import revalidate from '@/lib/revalidate';

export default async function Header({ navmenu, colormenu }) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/live`, {
    next: revalidate('REVALIDATE_HEADER')
  });

  const result = await res.json();
  const { data: live } = result;
  const hasItem = live && live.postTitle && live.postSlug ? true : false

  return (
    <>
    { hasItem === true && (
      <Box w="100%" bgColor="red.500" color="white">
        <Container>
          <Live live={live}/>
        </Container>
      </Box>
    )}

    <Box w="100%" bgColor="gray.500" color="white" borderTop={hasItem === false ? '4px solid' : ''} borderColor={hasItem === false ? 'blue.500' : ''}>
      <BaseMenu navmenu={navmenu} colormenu={colormenu}/>
    </Box>
    </>
  )
}
